import moment from "moment";

export const ALO_STATUSES = {
  AWAITING_PAYMENT: { label: "Awaiting payment", color: "gray" },
  PROCESSING: { label: "Processing", color: "blue" },
  DELIVERED: { label: "Delivered", color: "green" },
  PAYMENT_FAILED: { label: "Payment failed", color: "red" },
  NEEDS_ATTENTION: { label: "Needs attention", color: "orange" },
};

export const statusLabel = (status) =>
  (ALO_STATUSES[status] && ALO_STATUSES[status].label) || humanize(status);

export const humanize = (value) =>
  value
    ? String(value)
        .toLowerCase()
        .split("_")
        .map((word, i) => (i === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
        .join(" ")
    : "—";

// Dubai is UTC+4 all year round.
export const dubaiTime = (iso, pattern = "DD MMM YYYY, HH:mm") =>
  iso ? moment(iso).utcOffset(240).format(pattern) : "—";

export const toDateInput = (date) => moment(date).format("YYYY-MM-DD");

export const money = (amount, currency = "AED") =>
  amount === null || amount === undefined || amount === ""
    ? "—"
    : `${currency} ${Number(amount).toLocaleString("en-AE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;

/** 971501234567 -> +971 50 123 4567 */
export const displayPhone = (phone) => {
  if (!phone) return "—";
  const digits = String(phone).replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("971")) {
    return `+971 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  }
  return phone;
};

export const telHref = (phone) => `tel:+${String(phone || "").replace(/\D/g, "")}`;

export const groupCode = (code) => {
  const compact = String(code || "").replace(/\s+/g, "");
  return (compact.match(/.{1,4}/g) || [compact]).join(" ");
};

export const maskCode = (code) => groupCode(code).replace(/[^\s]/g, "•");
